import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const Header = () => {
    return ( 
        <div className="header-wrapper">
        <div className="header">
          <div className="nav">
            <span onClick={() => {window.scrollTo(0, 0)}}>sahilpatra</span>
          </div>
          <div className="links">
            <a href="https://www.linkedin.com/in/sahil-patra-69b13a136/" target="_blank" rel='noreferrer'>
              <LinkedInIcon className='icon'/>          
            </a>
            <a href="https://github.com/iamonjarvis/" target="_blank" rel='noreferrer'>
              <GitHubIcon className='icon'/>          
            </a>
          </div>
        </div>
      </div>

    );
}
 
export default Header;